@if (deviceService.isMobilePhone) {
    <ds-modal variant="surface">
        <ds-modal-content>
            <div [vnElementKey]="VanillaElements.QUICK_DEPOSIT_WRAPPER" class="player-quickdeposit-v2">
                <div class="player-quickdeposit-content-loading-v2">
                    <qd-feature />
                </div>
            </div>
        </ds-modal-content>
    </ds-modal>
} @else {
    <div [vnElementKey]="VanillaElements.QUICK_DEPOSIT_WRAPPER" class="player-quickdeposit quickdeposit-v2">
        <div class="player-quickdeposit-content-loading">
            <qd-feature />
        </div>
    </div>
}
